
import { renderRule as ebookDownload } from './ebookDownload/render';
export const items = [
  ebookDownload,
]